const _cache = new Map();

const _cachedColor = (key, compute) => {
    if (_cache.has(key)) return _cache.get(key);
    const result = compute();
    _cache.set(key, result);
    return result;
};

/**
 * @param rgba {string}
 * @param factor {number}
 * @return {string}
 */
export function brightenColor(rgba, factor = 1.3) {
    if (!rgba) return "rgba(255,255,255,1)";
    const key = `br:${rgba}:${factor}`;
    return _cachedColor(key, () => {
        let {r, g, b} = parseCurrentColor(rgba);
        r = Math.min(255, r * factor);
        g = Math.min(255, g * factor);
        b = Math.min(255, b * factor);
        return `rgba(${r},${g},${b},1)`;
    });
}

/**
 * @param rgba {string}
 * @return {{r: number, g: number, b: number}}
 */
function parseCurrentColor(rgba) {
    const parts = rgba.match(/rgba?\(([^)]+)\)/)[1]
        .split(",")
        .map(v => parseFloat(v.trim()));
    let [r, g, b, _ = 0.9] = parts;
    return {r, g, b};
}

/**
 * @param rgba {string}
 * @param factor {number}
 * @return {string}
 */
export function lightenColor(rgba, factor = 0.5) {
    if (!rgba) return "rgba(255,255,255,0.6)";
    const key = `lt:${rgba}:${factor}`;
    return _cachedColor(key, () => {
        let {r, g, b} = parseCurrentColor(rgba);
        r = Math.min(255, r + (255 - r) * factor);
        g = Math.min(255, g + (255 - g) * factor);
        b = Math.min(255, b + (255 - b) * factor);
        return `rgba(${r},${g},${b},0.6)`;
    });
}

/**
 * @param rgba {string}
 * @param factor {number}
 * @return {string}
 */
export function darkenColor(rgba, factor = 0.7) {
    if (!rgba) return 'rgba(0,0,0,1)';
    const key = `dk:${rgba}:${factor}`;
    return _cachedColor(key, () => {
        let { r, g, b } = parseCurrentColor(rgba);
        return `rgba(${Math.max(0, r*factor)},${Math.max(0, g*factor)},${Math.max(0, b*factor)},1)`;
    });
}